import React from 'react'
import { i18n } from '../../utils/translates/i18n'

/**
 * props:
 * - data
 * - onEditClick
 * - onStopClick
 * - onStartClick
 */
function UserRow(props) {
  return (
    <tr>
      <td>
        {props.data.isActive ? (
          <span className="badge bg-success me-2">Ativo</span>
        ) : (
          <span className="badge bg-danger me-2">Inativo</span>
        )}
        {props.data.nick}
      </td>
      <td>{props.data.name}</td>
      <td>{props.data.plan?.name}</td>
      <td>{i18n.t(props.data.group?.name)}</td>
      <td>{props.data.email}</td>
      <td>{props.data.indicant?.nick}</td>
      <td>
        {['developer', 'manager', 'admlotteries', 'support', 'finance'].includes(props.rule) && (
          <button
            id={'edit' + props.data.id}
            type="button"
            className="btn btn-secondary btn-xs ms-2"
            title="Edit this User"
            data-bs-toggle="modal"
            data-bs-target="#modalUser"
            onClick={props.onEditClick}>
            <svg
              className="icon icon-xs"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>{' '}
            {i18n.t('edit')}
          </button>
        )}
        {['developer', 'finance'].includes(props.rule) && (
          <button
            id={'binary' + props.data.id}
            type="button"
            className="btn btn-info btn-xs ms-2"
            title="Edit this User"
            data-bs-toggle="modal"
            data-bs-target="#modalBinaryUser"
            onClick={props.onBinaryClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="icon icon-xs">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z"
              />
            </svg>{' '}
            {i18n.t('binary')}
          </button>
        )}
      </td>
    </tr>
  )
}

export default UserRow
